
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"86","height":"86"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_47621","data-name":"Group 47621","transform":"translate(-918 -495)"}},[_c('g',{attrs:{"id":"Group_47620","data-name":"Group 47620","transform":"translate(0 -18)","fill":"#ecf0f5"}},[_c('circle',{attrs:{"id":"Ellipse_859","data-name":"Ellipse 859","cx":"43","cy":"43","r":"43","transform":"translate(918 513)","opacity":".452"}}),_c('circle',{attrs:{"id":"Ellipse_860","data-name":"Ellipse 860","cx":"33","cy":"33","r":"33","transform":"translate(928 522.999)"}})]),_c('path',{attrs:{"id":"Positive_Icon","data-name":"Positive Icon","d":"M11.886 21.182a3.662 3.662 0 01-5.183 0l-5.631-5.627a3.666 3.666 0 015.183-5.187l3.039 3.039L21.626 1.075a3.665 3.665 0 015.183 5.183z","transform":"translate(947.045 527)","fill":"#5858ec"}})])])
          )
        }
      }
    